<template>
  <div>
    <div v-if="!currentOrder.id">
      <oms-loading :loading="!currentOrder.id"></oms-loading>
    </div>
    <div v-else="" class="page-main-body padding in-order-info">
      <el-row style="margin-bottom:0">
        <oms-col :value="currentOrder.orderNo" label="货主订单号"/>
        <oms-col :value="currentOrder.upstreamOrgName" label="货主"/>
        <oms-col label="订单货品类型" :isShow="currentOrder.orderGoodsType">
          <dict dict-group="orderGoodsType"
                :dict-key=" currentOrder.orderGoodsType === null?currentOrder.orderGoodsType:'' + currentOrder.orderGoodsType"></dict>
        </oms-col>
        <oms-col label="业务类型" :value="currentOrder.bizType">
          <dict :dict-group="'bspBizType'" :dict-key="currentOrder.bizType"></dict>
        </oms-col>
        <oms-col :label="`${$formatOrderType(type)}订单`" :value="currentOrder.orderThirdNo"/>
        <oms-col :label="$formatOrderType(type)" :value="currentOrder.downstreamOrgName"/>
        <oms-col :value="currentOrder.transportationMeans" label="物流方式">
          <dict :dict-group="type === 0 ? 'transportationMeans' : 'outTransportMeans'"
                :dict-key="currentOrder.transportationMeans"></dict>
        </oms-col>
        <oms-col label="物流商" :value="currentOrder.thirdLogisticsName"/>
        <template v-if="isInOrder">
          <oms-col label="配送地址" :value="currentOrder.upstreamOrgAddress"/>
          <oms-col label="提货地址" :value="currentOrder.shippingAddress"/>
          <oms-col label="申请人" :value="currentOrder.consigneeName"/>
        </template>
        <template v-else>
          <oms-col label="配送地址" :value="currentOrder.shippingAddress"/>
          <oms-col :value="currentOrder.upstreamOrgAddress" label="货主仓库地址"/>
          <oms-col label="实际收货人" :value="currentOrder.consigneeName"/>
          <oms-col label="联系电话" :value="currentOrder.consigneePhone"/>
        </template>
        <oms-col :value="currentOrder.transportationCondition" label="运输条件">
          <dict :dict-group="'transportationCondition'" :dict-key="currentOrder.transportationCondition"></dict>
        </oms-col>
        <oms-col label="物流中心" :value="currentOrder.logisticsCentreName"/>
        <oms-col label="下单时间" :value="currentOrder.createTime | minute"/>
        <oms-col :label="`预计${isInOrder?'入': '出'}库时间`" :value="currentOrder.estimatedExecutionTime | minute"/>
        <oms-col label="完成时间" :value="currentOrder.completeTime | minute"/>
        <oms-col label="是否合格" :is-show="true" :value="currentOrder.qualifiedFlag"
                 v-show="(typeof currentOrder.qualifiedFlag === 'boolean') && currentOrder.bizType === '1-1'">
          <span class="goods-span" v-show="currentOrder.qualifiedFlag">合格</span>
          <span class="goods-span" v-show="!currentOrder.qualifiedFlag">不合格</span>
        </oms-col>
        <oms-col label="订单状态" :is-show="true">{{ getCurrentOrderStatus(currentOrder.status) }}</oms-col>
        <oms-col label="备注" :value="currentOrder.orderRemark"/>
      </el-row>
      <hr class="hr"/>
      <order-goods-list :data="currentOrder.details"/>
    </div>
  </div>
</template>
<script>
  import utils from '@/tools/utils';
  import OrderGoodsList from './order-goods-list';

  export default {
    components: {OrderGoodsList},
    props: {
      currentOrder: {
        type: Object,
        default: function () {
          return {};
        }
      },
      orgType: Object,
      type: Number
    },
    computed: {
      isInOrder() { // 入库订单
        return this.type === 0;
      },
    },
    methods: {
      getCurrentOrderStatus: function (status) {// 获取订单状态
        let retstatus = '';
        let orgType = utils[this.type === 0 ? 'inBspOrderType' : 'outBspOrderType'];
        for (let key in orgType) {
          if (status === orgType[key].status) {
            retstatus = orgType[key].title;
          }
        }
        return retstatus;
      }
    }
  };
</script>
